import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BenefitsSectionPlanPage1 from "./BenefitsSectionPlanPage1";
import BenefitsSectionPlanPage2 from "./BenefitsSectionPlanPage2";
import { useTranslation } from "../../Hooks/useTranslation";
import "../../Components/test.css";

export const BenefitSectionPlanPage = ({ handleFooter, callBackSection }) => {
  const translations = useTranslation();

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: false,
  };

  return (
    <div className="scroll-section vertical-section section overflow-hidden benefits-plan-section">
      <div className="desktop-slider">
        <Slider {...settings} className="vs-slider relative w-[100%]">
          <BenefitsSectionPlanPage1 key="universal" />
          <BenefitsSectionPlanPage2 key="term" />
        </Slider>
      </div>
    </div>
  );
};

export default BenefitSectionPlanPage;
